import React from 'react';
import {Trans} from 'react-i18next';

export default function NotifiedNote({handleClose}) {
  return (
    <div className="note note-warning">
      <div className="note-close">
        <button type="button" className="close" onClick={handleClose}>
          <i className="la la-close" />
        </button>
      </div>
      <div>
        <Trans i18nKey="p.s.uiconfiguration.upgrade.reminder">
          New feature is now live! Click "<strong>Publish to Online</strong>" to
          update the UI settings. Ensure you update and restart the app to enjoy
          the latest feature and enhance your overall experience.
        </Trans>
      </div>
    </div>
  );
}
